import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PostMissingDocsEmail } from 'domain/usecases/vendors/post-missing-docs-email';
import { showToast, TOAST_ERROR, TOAST_SUCCESS, FIVE_SECONDS } from '../../lib/utils';
import { makeRemoteSendMissingDocsEmail } from '../../main/factories/usecases/vendors';

export const useSendMissingDocsEmail = () => {
  const queryClient = useQueryClient();
  const sendEmailService = makeRemoteSendMissingDocsEmail();

  return useMutation({
    mutationFn: async (params: PostMissingDocsEmail.Params) => {
      return await sendEmailService.send(params);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: ['vendor-email', variables.locationId, variables.accountId] });
      // Wait a moment before invalidating the email whitelist to ensure backend processing is complete
      setTimeout(async () => {
        await queryClient.invalidateQueries({ queryKey: ['emailWhitelist', variables.locationId] });
      }, 1000);
      if (variables.dryRun) {
        showToast('Dry run completed successfully', TOAST_SUCCESS, FIVE_SECONDS);
      } else {
        showToast('Missing docs email sent successfully', TOAST_SUCCESS, FIVE_SECONDS);
      }
    },
    onError: (error: Error) => {
      showToast(error.message || 'Error sending missing docs email', TOAST_ERROR, FIVE_SECONDS);
    },
  });
};
